import { useCallback, useEffect, useRef, useState } from "react";

// Light auto-refresh: polls only while the tab is visible, and refreshes instantly
// when the user comes back to the window. No sockets, no load on idle tabs.
export const useAutoRefresh = (loader, everyMs = 30000) => {
  const [at, setAt] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = useRef(loader);
  run.current = loader;

  const refresh = useCallback(async () => {
    setBusy(true);
    try {
      await run.current();
      setAt(new Date());
    } finally {
      setBusy(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const tick = () => {
      if (!document.hidden) refresh();
    };
    const timer = setInterval(tick, everyMs);
    window.addEventListener("focus", tick);
    document.addEventListener("visibilitychange", tick);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", tick);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [refresh, everyMs]);

  return { refresh, at, busy };
};
